import React from 'react';
import { graphql, useStaticQuery } from "gatsby";
import { Helmet } from 'react-helmet';
import Section from '../../components/Layout/Section/Section';
import InnerContainer from '../../components/Layout/InnerContainer/InnerContainer';
import Main from "../../components/Layout/Main";
import Wave from '../../components/Dividers/wave';
import PreviewCompatibleImage from '../../components/Utils/PreviewCompatibleImage';
import Star from '../../components/Dividers/star';
import ThreeStar from '../../components/Dividers/ThreeStar';

import './thank-you.scss';

const Index = () => {
  const { markdownRemark } = useStaticQuery(graphql`
    query ThankYouQuery {
      markdownRemark(frontmatter: { pageId: { eq: "thank-you-page" } }) {
        frontmatter {
          components {
            type
            images {
              image {
                childImageSharp {
                  fluid(maxWidth: 2048, quality: 80) {
                    ...GatsbyImageSharpFluid
                  }
                }
                extension
                publicURL
              }
            }
          }
        }
      }
    }
  `)
  
  function getComponent(name) {
    const components = markdownRemark.frontmatter.components;
    return components.filter(component => component.type === name)[0];
  }
  
  const LogoGroupOne = getComponent("logo-group-1");
  const LogoGroupTwo = getComponent("logo-group-2");
  const LogoGroupThree = getComponent("logo-group-3");
  const LogoGroupFour = getComponent("logo-group-4");
  const LogoGroupFive = getComponent("logo-group-5");
  const LogoGroupSix = getComponent("logo-group-6");

  return (
    <Main>
      <Helmet>
        <body className="thank-you-page" />
      </Helmet>
      <Section>
        <InnerContainer customClass="hero">
          <Star customClass="star--top"/>
          <svg className="logo-with-date" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1291.2 291.63">
          <path className="cls-2" d="M273.8,1.41l-57.9,57.8L158,1.41H1v74.3l214.9,214.5L430.8,75.71v214.5H594.7v-81.1l50.6,50.1,50.6-50.1v81.1h26.3c-.2-4.8-.4-16.2-.4-22.4,0-34.4,3-42.2,3-91.7,0-14.8-3.3-18.4-8.1-18.4-5.3,0-14.5,7.4-24.4,14.4-16,11.3-24.5,20.4-34.9,20.4-6.1,0-9.6-2.7-13.4-7.6a17.49,17.49,0,0,1-2.8-8.3c0-3.7,1.5-7.9,7.1-11.3,6.1-3.7,12.8-3,27.2-11.7,17.1-10.3,33.2-19.5,36.4-21.6,5.9-3.1,4.5-7.8,4.5-12.2,0-9.6,8.6-12.9,16-12.9a25.74,25.74,0,0,1,12.5,3.1c2.7-1.5,9.5-5.4,22.4-13.3,8.5-5.2,13-15.3,23.1-15.3,4.2,0,8,.8,11.4,3.6,5,4.1,5.9,6.4,5.9,9.9,0,7.9-12.2,14.5-18.7,18.4-19.8,12-26.1,15-33.3,19.6,1,4.3.3,16.5.3,25.5,0,15,3.3,42.6,3.3,58.1,0,18.4-.8,41.2-.8,46.9a241.41,241.41,0,0,0,1.9,26.8h257l57.9-57.8,57.9,57.8h157v-74.3L1075.4,1.41,860.5,215.91v-42.3a342.06,342.06,0,0,0-25.1,65.8c-4.8,16.5-6.8,23.5-16.9,23.5-9.2,0-12.3-2-16.5-13.2s-18.6-48.4-19.7-51.3c-7.7-20.2-12.1-35.6-12.1-44.4,0-15.6,11-21.4,21.4-21.4,14.1,0,16.6,13.4,18.5,26,1,6.5,1.6,24.6,2.6,34,.5,4.4,0,8.4,5,8.4,4.5,0,6.5-12.6,9.9-21.5,12-32.2,27.8-62.3,32.9-70.1V1.41H703l-57.8,57.8L587.4,1.41Z"/>
          </svg>
            <h3 className="section-header">THANK YOU TO OUR PARTNERS! </h3>
          <Star customClass="star--bottom"/>
        </InnerContainer>
      </Section>
      <Section customClass="small-boxes">
        <InnerContainer customClass={["small-boxes__container", "threeUp"]}>
          <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={LogoGroupOne.images[0].image} alt="image" />
          <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={LogoGroupOne.images[1].image} alt="image" />
          <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={LogoGroupOne.images[2].image} alt="image" />
        </InnerContainer>
        <Wave/>
      </Section>
      <ThreeStar/>
      <Section customClass="small-boxes">
        <InnerContainer customClass={["small-boxes__container", "threeUp"]}>
          <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={LogoGroupTwo.images[0].image} alt="image" />
          <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={LogoGroupTwo.images[1].image} alt="image" />
          <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={LogoGroupTwo.images[2].image} alt="image" />
        </InnerContainer>
        <Wave/>
      </Section>
      <ThreeStar/>
      <Section customClass="small-boxes">
        <InnerContainer customClass={["small-boxes__container", "threeUp"]}>
          <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={LogoGroupThree.images[0].image} alt="image" />
          <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={LogoGroupThree.images[1].image} alt="image" />
          <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={LogoGroupThree.images[2].image} alt="image" />
        </InnerContainer>
        <Wave/>
      </Section>
      <ThreeStar/>
      <Section customClass="small-boxes">
        <InnerContainer customClass={["small-boxes__container", "threeUp"]}>
          <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={LogoGroupFour.images[0].image} alt="image" />
          <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={LogoGroupFour.images[1].image} alt="image" />
          <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={LogoGroupFour.images[2].image} alt="image" />
        </InnerContainer>
        <Wave/>
      </Section>
      <ThreeStar/>
      <Section customClass="small-boxes">
        <InnerContainer customClass={["small-boxes__container", "threeUp"]}>
          <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={LogoGroupFive.images[0].image} alt="image" />
          <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={LogoGroupFive.images[1].image} alt="image" />
          <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={LogoGroupFive.images[2].image} alt="image" />
        </InnerContainer>
        <Wave/>
      </Section>
      <ThreeStar/>
      <Section customClass="small-boxes">
        <InnerContainer customClass={["small-boxes__container", "threeUp"]}>
          <PreviewCompatibleImage customClassName="small-boxes__container__image blank" imageInfo={LogoGroupSix.images[0].image} alt="image" />
          <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={LogoGroupSix.images[1].image} alt="image" />
          <PreviewCompatibleImage customClassName="small-boxes__container__image blank" imageInfo={LogoGroupSix.images[2].image} alt="image" />
        </InnerContainer>
        <Wave/>
      </Section>
    </Main>
  );
}

export default Index
